import { serviceDashboardOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { faHammer } from "@fortawesome/pro-light-svg-icons";
import FaIcon from "../components/FaIcon";
import React from "react";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("service-cockpit"),
  endpoint: "service-dashboard",
  operations: serviceDashboardOps,
  roleView: [ROLE.CUSTOMER_VIEW, ROLE.CUSTOMER_ADMIN, ROLE.CONTAINER_ADMIN, ROLE.CONTAINER_VIEW, ROLE.APP_SERVICE_USER],
  roleAdmin: [ROLE.CUSTOMER_ADMIN],
  singularName: (t) => t("Service cockpit"),
  name: (t) => t("Service cockpit"),
  icon: <FaIcon icon={faHammer} size={"lg"} />,
  syncCustomerFilter: true,
});
export default conf;
